import { registerComponent } from '@gig/magic-common';
import QuestionnaireTemplate from './questionnaire.vue.js';

var Questionnaire = registerComponent(QuestionnaireTemplate);

export { Questionnaire };
